import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class ConsumerModel {
  constructor(consumerType: ConsumerType) {
    this.consumerType = consumerType;
  }

  id: number;
  // Common Data
  deviceType: number;
  power: number;
  chargePower?: number;
  manufacturer: string;
  deviceTypeName: string;
  count: number; //
  location: 'Private' | 'Public';
  sitePlanAvailable: boolean;
  chargeDeviceAvailable: boolean;
  chargingPointsNumber: number;
  manufacturerDeclaration: boolean;
  extractionPowerMax: number;
  feedPowerMax: number;
  chargingRangeFrom: number;
  chargingRateTo: number;
  interruptibleChargingSystem: boolean;
  acCurrent: number;
  chargingStationInterface: boolean;
  heatPumpType: number;
  powerDIN: number;
  consumptionPower: number;
  heatingPower: number;
  performancePower: number;
  maxConsumptionPower: number;
  maxStartingCurrent: number;
  hotWaterSupplyType: string;
  hotWaterSupplyPowerUsage: number;
  roomHeatingType: string;
  roomHeatingSupplyPowerUsage: number;
  operationalMode: number;
  heatSource: number;
  switchingTime: string;
  enwgP14aModule: 'Module1' | 'Module2' | 'Module3';
  enwgP14aAcceptedAGBs?: boolean;
  rateLimitingType: 'Direct' | 'EMS' | 'NotControlled';
  meterNumber: string;
  noMeterPresent?: boolean;
  meterOperator: string;
  controllability: 'NB' | 'WMSB';
  isP14aStvoException: boolean;
  consumerType: ConsumerType;
  chargerType?: ChargerType;
  maLo?: string;
}

export type ConsumerForm = TypedForm<Omit<ConsumerModel, 'enwgP14aAcceptedAGBs' | 'noMeterPresent'>>;

export type ConsumerFormV2 = TypedForm<ConsumerModel>;

export enum ConsumerTypeEnum {
  Charger = 'Charger',
  Storage = 'Storage',
  EHeating = 'EHeating',
  Misc = 'Misc'
}

export type ConsumerType = `${ConsumerTypeEnum}`;

export const ConsumerTypeDisplayNames: Record<ConsumerType, string> = {
  [ConsumerTypeEnum.Charger]: 'Ladeeinrichtung',
  [ConsumerTypeEnum.Storage]: 'Speicher',
  [ConsumerTypeEnum.EHeating]: 'E-Heizung / Wärmepumpe / Raumkühlanlage',
  [ConsumerTypeEnum.Misc]: 'Sonstige Verbraucher'
};

/** Module der Netzentgeltreduzierung nach § 14a EnWG, wie im Formular beschriftet. */
export const ConsumerP14aModuleDisplayNames: Record<ConsumerModel['enwgP14aModule'], string> = {
  Module1: 'Modul 1',
  Module2: 'Modul 2',
  Module3: 'Modul 3'
};

export enum ChargerType {
  AC = 'AC',
  DC = 'DC',
  Wallbox = 'Wallbox'
}

export const ChargerTypeConst = {
  [ChargerType.AC]: {
    value: ChargerType.AC,
    displayName: 'AC-Ladesäule'
  },
  [ChargerType.DC]: {
    value: ChargerType.DC,
    displayName: 'DC-Ladesäule'
  },
  [ChargerType.Wallbox]: {
    value: ChargerType.Wallbox,
    displayName: 'Wallbox'
  }
};
